import React, {useState, useEffect} from 'react'
import {Form, Input, Row, Col, Button} from 'antd'
import Layouts from '../components/Layouts'

const UserDetails = () => {
  const [user, setUser] = useState()
  useEffect(() => {
    const UserDetails = JSON.parse(localStorage.getItem('user'))
    console.log('UserDetails', UserDetails)
    setUser(UserDetails)
  }, [])
  // useEffect(() => {
  //   fetch(process.env.REACT_APP_BASE_URL_ADMIN + '/User/Details')
  //     .then(res => res.json())
  //     .then(data => {
  //       if (data) {
  //         setUser({
  //           name: data.name,
  //           email: data.email,
  //           phone: data.phone,
  //           address: data.address,
  //         })
  //       }
  //     })
  // }, [])

  return (
    <div title="User Details" className="ant-layout-content dashboard" >
      <div className="dash-bg-white">
        <Row gutter={[16, 16]}>
          <Col xs={12} sm={24} md={24} lg={12}>
            <div className="section-top-heading">
              <h3
                style={{
                  color: '#0C1362',
                  fontWeight: '600',
                  fontSize: '20px',
                }}>
                {' '}
                User Detail
              </h3>
            </div>
          </Col>
        </Row>
      </div>
      <div className="dash-bg-white">
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={24} md={12} lg={8}>
            <h3>Name</h3>
            <p>{user?.FirstName} {user?.LastName}</p>
          </Col>
          <Col xs={24} sm={24} md={12} lg={8}>
            <h3>Email</h3>
            <p>{user?.email || '-'}</p>
          </Col>
          <Col xs={24} sm={24} md={12} lg={8}>
            <h3>Phone</h3>
            <p>{user?.MobileNumber || '-'}</p>
          </Col>
          <Col xs={24} sm={24} md={12} lg={8}>
            <h3>Address</h3>
            <p>{user?.address || '-'}</p>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default UserDetails
